import FormikInputOnly from "./formik-input-only";
import FormikUppercaseInputOnly from "./formik-uppercase-input-only";

export default FormikInputOnly;
export { FormikInputOnly, FormikUppercaseInputOnly };
